module.exports = __webpack_public_path__ + "img/radio-mutiara (1).0dd1063b.jpg";